// extracted by mini-css-extract-plugin
export default {"container":"screening_container__2MnnG","venue":"screening_venue__2xAni","title":"screening_title__10gUx"};